import React, { useEffect, useState } from "react";

import { isApiOffline, subscribeApiOffline } from "./connectionState";

/** Small banner while the server can't be reached (QA batch 16, NAV-026). */
export const ConnectionBanner: React.FC = () => {
  const [offline, setOffline] = useState(isApiOffline);
  useEffect(() => {
    setOffline(isApiOffline());
    return subscribeApiOffline(() => setOffline(isApiOffline()));
  }, []);
  if (!offline) return null;
  return (
    <div
      role={"status"}
      className={
        "fixed left-1/2 top-3 z-[2000] -translate-x-1/2 rounded-full bg-[#1F2433] px-4 py-2 text-[13px] font-semibold text-white shadow-lg"
      }>
      Can't reach ProCharted — retrying…
    </div>
  );
};
